import NewReplacementDelivery from "../../../../components/@documents/replacement_delivery/NewReplacementDelivery";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ReplacementDeliveryNewPage() {

    return (
        <NewReplacementDelivery 
            routeType={routeTypes.workstation}
        />
    )
}